import useCookies from './useCookies';
import getDomain from '../utils/getDomain';

/**
 * Custom hook for setting FBC cookie based on response data
 * @returns {Function} setFbcCookie function
 */
const useSetFbcCookie = () => {
  const { getCookie, setCookie } = useCookies();

  /**
   * Sets the _fbc cookie if it doesn't exist and response data contains valid _fbc value
   * @param {Object} responseData - Response data containing _fbc value
   */
  const setFbcCookie = (payload) => {
    try {
      const _fbcCookie = getCookie('_fbc');
      console.log('current _fbc Cookie:', _fbcCookie);

      if (!_fbcCookie) {
        if (payload._fbc && payload._fbc !== 'NA' && payload._fbc !== 'N/A') {
          console.log('Setting _fbc Cookie from DynamoDB:', payload._fbc);
          setCookie('_fbc', payload._fbc, {
            expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
            path: '/',
            domain: getDomain(),
          });
        } else {
          console.log('No FBC Cookie found in DynamoDB');
        }
      }
    } catch (error) {
      console.error('Error in setFbcCookie:', error);
    }
  };

  return setFbcCookie;
};

export default useSetFbcCookie;
